import React, { useState } from "react";

const Page19 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div style={{paddingTop: '100px'}}>
        <div className="col-md-12 fontS-18" style={{color: '#000000'}}>
          <p>
            Mas como isso acontece na prática, durante uma mudança real? Acompanhe a seguir.
          </p>
          <br />
        </div>

      {/* Vídeo centralizado */}
      <div className="row justify-content-center" >
        <div className="col-md-10">
          <div
            style={{
              position: "relative",
              paddingBottom: "52.25%", // proporção 16:9
              height: 0,
              overflow: "hidden",
              borderRadius: "8px",
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/g78C5kcdJLE"
              title="Vídeo sobre Normas Técnicas - Acessível"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "90%",
                borderRadius: "8px",
              }}
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page19;